import {writable} from 'svelte/store';
import {I_REQUEST} from "../../../../../lib/datatypes";
import {sortCompareDESC} from "../../../../../lib/utils";

export const requests = writable({
    list: [],
    lookup: {},
});
export const requests_fetching = writable(false);

const _createLookup = list => {
    let result = {};
    for(let i = 0, n = list.length; i < n; i++) {
        result[list[i][I_REQUEST.ID]] = list[i];
    }
    return result;
};


const _updateStructures = requests => {
    requests.list.sort((a, b) => sortCompareDESC(a[I_REQUEST.UPDATED], b[I_REQUEST.UPDATED]));
    requests.lookup = _createLookup(requests.list);
};

let $requests = null;
const unsubscribe = requests.subscribe(val => $requests = val);

// Explicitly set the contents of requests by passing them in, ie from bootstrapped data
export const setRequests = requests_data => {
    requests.update(requests => {
        requests.list = requests_data;
        _updateStructures(requests);
        return requests;
    });
};

export const loadRequests = async () => {
    requests_fetching.set(true);

    const response = await fetch(`/api/requests`);
    let result = await response.json();
    requests_fetching.set(false);
    requests.update(requests => {
        requests.list = result;
        _updateStructures(requests);
        return requests;
    });
};

export const addRawRequest = async request_arr => {
    requests_fetching.set(true);

    const url = `/api/request/add`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(request_arr)
    });
    let result = await response.json();
    requests_fetching.set(false);
    requests.update(requests => {
        requests.list.push(result);
        _updateStructures(requests);
        return requests;
    });
    return result;
};

export const updateRawRequest = async request_arr => {
    requests_fetching.set(true);

    const url = `/api/request/${request_arr[I_REQUEST.ID]}/update`;
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(request_arr)
    });
    let result = await response.json();
    // console.log(response, result);
    // ..update local copy of requests with the updated data - could just download the data again (server would have updated data), but..
    const i = $requests.list.findIndex(el => el[I_REQUEST.ID] === request_arr[I_REQUEST.ID]);
    requests_fetching.set(false);
    requests.update(requests => {
        requests.list[i] = result;  // @ASSUMPTION that the result will always contain a successful object, ie doesn't handle errors
        _updateStructures(requests);
        return requests;
    });
    return result;
};